import Icon from '../components/Icon';

const Instagram = Icon(
  'instagram',
  <>
    <path d="M17.139 5.03a1.32 1.32 0 1 1 1.466 2.196A1.32 1.32 0 0 1 17.14 5.03" />
    <path
      fillRule="evenodd"
      d="M12 6.35a5.65 5.65 0 1 0 0 11.3 5.65 5.65 0 0 0 0-11.3M8.35 12a3.65 3.65 0 1 1 7.3 0 3.65 3.65 0 0 1-7.3 0"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M7.465 1.066C8.638 1.013 9.013 1 12 1s3.362.012 4.535.067c.912.018 1.815.19 2.67.51.734.276 1.399.71 1.948 1.269.56.55.994 1.215 1.27 1.949.32.855.493 1.758.511 2.67C22.987 8.638 23 9.013 23 12s-.012 3.362-.067 4.535a8.1 8.1 0 0 1-.51 2.67 5.63 5.63 0 0 1-3.218 3.218 8.1 8.1 0 0 1-2.67.511C15.362 22.987 14.987 23 12 23s-3.362-.012-4.535-.067a8.1 8.1 0 0 1-2.67-.51 5.4 5.4 0 0 1-1.948-1.269 5.4 5.4 0 0 1-1.27-1.949 8.1 8.1 0 0 1-.511-2.67C1.013 15.362 1 14.987 1 12s.012-3.362.067-4.535c.018-.912.19-1.815.51-2.67a5.4 5.4 0 0 1 1.269-1.948 5.4 5.4 0 0 1 1.949-1.27 8.1 8.1 0 0 1 2.67-.511m8.98 1.98c-1.16-.053-1.508-.064-4.445-.064s-3.285.011-4.445.064a6.1 6.1 0 0 0-2.042.379c-.478.176-.91.458-1.265.823a3.4 3.4 0 0 0-.823 1.265 6.1 6.1 0 0 0-.379 2.042c-.053 1.16-.064 1.508-.064 4.445s.011 3.285.064 4.445c.008.697.137 1.388.379 2.042.176.478.458.91.823 1.265.355.365.786.646 1.264.823.654.242 1.345.37 2.043.379 1.16.053 1.508.064 4.445.064s3.285-.011 4.445-.064a6.1 6.1 0 0 0 2.042-.379 3.64 3.64 0 0 0 2.088-2.088c.242-.654.37-1.345.379-2.042.053-1.16.064-1.508.064-4.445s-.011-3.285-.064-4.445a6.1 6.1 0 0 0-.379-2.042 3.4 3.4 0 0 0-.823-1.265 3.4 3.4 0 0 0-1.265-.823 6.1 6.1 0 0 0-2.042-.379"
      clipRule="evenodd"
    />
  </>
);

export default Instagram;
